<template>
    <div class="">
        <div :class="[popupmodalActive ? 'open' : '', theme == 'white' ?'text-dark' : 'text-white']" class="w-100 popupmodal position-fixed p-3">
            <div :class="[theme == 'dark' ? 'bg-fourth-'+theme : 'bg-specialbackground-'+theme]" class="w-100 popupmodal__inner d-flex align-items-center justify-content-center">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="24px" height="18px" viewBox="0 0 78.369 78.369" style="enable-background:new 0 0 78.369 78.369;"
                     xml:space="preserve">
                <g>
                    <path :fill="svgcolor1" d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
                        c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
                        C78.477,17.894,78.477,18.586,78.049,19.015z"/>
                </g>
            </svg>
                <p class="pl-5">{{ t('general.basketsuccess') }}</p>
            </div>
        </div>
        <div :class="[popupmodalFailureActive ? 'open' : '', theme == 'white' ?'text-dark' : 'text-white']" class="w-100 popupmodal position-fixed p-3">
            <div :class="[theme == 'dark' ? 'bg-fourth-'+theme : 'bg-specialbackground-'+theme]" class="w-100 popupmodal__inner d-flex align-items-center justify-content-center">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="24px" height="18px" viewBox="0 0 78.369 78.369" style="enable-background:new 0 0 78.369 78.369;"
                     xml:space="preserve">
                <g>
                    <path :fill="svgcolor1" d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
                        c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
                        C78.477,17.894,78.477,18.586,78.049,19.015z"/>
                </g>
            </svg>
                <p class="pl-5">{{ t('general.basketaddfailure') }}</p>
            </div>
        </div>
        <filters v-if="activatefilter == 1" @applyFilters="getFilters" :theme="theme"  :filters='propertyfilters' :amount="cardsFiltered.length"></filters>
        <div v-if="cardsFiltered.length != 0">
            <div v-for="(card, index) in cardsFiltered" class="d-flex px-3 px-lg-0 flex-column sparepartsproductselection__productlist__item" :class="'sparepartsproductselection__productlist__item--'+theme">
                <div class="d-flex">
                    <div class="sparepartsproductselection__productlist__item__img">
                        <div v-if="card.fabricId && card.img != null && card.img != '//suncomfort.glatz.com/media/glatz_thumbnail.png' && card.img != ''" :class="'bg-specialbackground-'+theme" class="sparepartsproductselection__productlist__item__img__inner sparepartsproductselection__productlist__item__img__inner--fabric" :style="{ backgroundImage: 'url(' + card.img + ')' }"></div>
                        <!-- if type id is 85 / Überzug -->
                        <div v-else-if="card.type[0].id == 85 && card.img != null && card.img != '//suncomfort.glatz.com/media/glatz_thumbnail.png' && card.img != ''" :class="'bg-specialbackground-'+theme" class="sparepartsproductselection__productlist__item__img__inner sparepartsproductselection__productlist__item__img__inner--fabric" :style="{ backgroundImage: 'url(' + card.img + ')' }"></div>
                        <div v-else class="sparepartsproductselection__productlist__item__img__inner" :class="'bg-specialbackground-'+theme" :style="{ backgroundImage: 'url(' + card.img + ')' }"></div>
                        <div v-if="card.repairlevel != null && card.repairlevel != ''" class="mt-1 p-3 d-flex flex-column-reverse flex-md-row justify-content-between w-100 align-items-start align-items-md-center" :class="theme == 'white' ? 'bg-specialbackground-'+theme : 'bg-third-'+theme">
                            <p class="pt-1 pt-md-0">
                                {{ t('general.reparedifficult') }}<br>
                                <span>{{ card.repairlevel }}</span>
                            </p>
                            <svg id="help-button" xmlns="http://www.w3.org/2000/svg" width="19.499" height="19.499" viewBox="0 0 19.499 19.499">
                                <g id="Gruppe_1508" data-name="Gruppe 1508">
                                    <path id="Pfad_8248" data-name="Pfad 8248" d="M9.75,19.5A9.75,9.75,0,1,1,19.5,9.75,9.76,9.76,0,0,1,9.75,19.5ZM9.75.75a9,9,0,1,0,9,9A9.01,9.01,0,0,0,9.75.75Z" fill="#fff"/>
                                </g>
                                <g id="Gruppe_1510" data-name="Gruppe 1510" transform="translate(8.801 3.871)">
                                    <g id="Gruppe_1509" data-name="Gruppe 1509">
                                        <path id="Pfad_8249" data-name="Pfad 8249" d="M192.667,84.86a.949.949,0,0,1-1.9,0,.933.933,0,0,1,.957-.957A.909.909,0,0,1,192.667,84.86Zm-1.705,10.79V87.227h1.531v8.423Z" transform="translate(-190.77 -83.903)" fill="#fff"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="sparepartsproductselection__productlist__item__details w-100 pl-3 pl-md-5 pt-2 pt-md-1">
                        <h2>{{ card.label }}</h2>
                        <div class="row flex-column-reverse flex-md-row pt-0 pt-md-4">
                            <div class="col-12 col-md-8 w-100 h-100">
                                <div class="w-100 h-100 detailContainer position-fixed position-md-static top-0 left-0" :class="[detailopen == index ? 'open' : '', 'bg-'+theme]">
                                    <div class="d-flex row mx-0">
                                        <div @click="toggleDetail('undefined')" class="backToSection position-relative w-100 d-flex px-1 py-3 d-md-none justify-content-start align-items-center" :class="'backToSection--'+theme">
                                            <template v-if="theme == 'white'">
                                                <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5">
                                                    <path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" fill="#000" opacity="0.8"></path>
                                                </svg>
                                                <svg class="d-none cross position-absolute" height="12" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="_02_User" data-name="02 User">
                                                        <path fill="#000" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"/>
                                                        <path fill="#000" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"/>
                                                    </g>
                                                </svg>
                                            </template>
                                            <template v-else>
                                                <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5">
                                                    <path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" fill="#fff" opacity="0.8"></path>
                                                </svg>
                                                <svg class="d-none cross position-absolute" height="12" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="_02_User" data-name="02 User">
                                                        <path fill="#fff" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"/>
                                                        <path fill="#fff" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"/>
                                                    </g>
                                                </svg>
                                            </template>
                                            <p class="py-3 pl-5">{{ t('pagination.previous') }}</p>
                                        </div>
                                        <h2 class="pl-3 pt-5 d-block d-md-none">{{ card.productId }} {{ card.label }}</h2>
                                        <div class="col-12 pl-3 pl-md-0 pt-2" :class="[index % 2 == 0 ? 'col-md-7 col-xl-5' : 'col-md-5 col-xl-7']" v-for="(detail, index) in card.details">
                                            <div class="pt-4 pt-md-2">
                                                <h3>{{ t('general.' + detail['codeLabel']) }}</h3>
                                                <h3 class="pt-1"><span v-html="detail['value']"></span></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="card.helpvideo != '' && card.helpvideo != null">
                                    <div class="videolink pt-3 pt-md-5 pt-md-2 pt-md-5 d-flex align-items-center" @click="vidopen = index">
                                        <p class="text-secondary-dark" :class="'text-secondary-'+theme">{{ t('general.helprepare') }}</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="7.385" viewBox="0 0 24 7.385">
                                            <path id="Pfad_8247" data-name="Pfad 8247" d="M19.139,8.308v2.9H0v1.223H19.139v3.264L24,11.9Z" transform="translate(0 -8.308)" :fill="svgcolor1" fill-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                    <div :id="'videoPopup-'+card.productId" :class="[vidopen == index ? 'open' : '']" class="videoPopup position-fixed d-flex justify-content-center align-items-center vh-100 min-vw-100">
                                        <iframe :src="card.helpvideo+'?enablejsapi=1'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>
                                    <div class="videoPopupCloser position-fixed" :class="[vidopen == index ? 'open' : '']" @click="closeYoutubeVideo('videoPopup-'+card.productId, index)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                            <path id="close.2" d="M40,2.357,37.643,0,20,17.643,2.357,0,0,2.357,17.643,20,0,37.643,2.357,40,20,22.357,37.643,40,40,37.643,22.357,20Z" fill="#fff"/>
                                        </svg>
                                    </div>
                                </template>
                            </div>
                            <div class="col-12 col-md-4 d-flex flex-column align-items-start align-items-md-end pt-0 pt-md-4">
                                <template v-if="basketLoaded == true">
                                <h4 v-if="card.accessible == 0" class="accessible accessible0 pt-4"> {{ t('general.available') }}</h4>
                                <h4 v-if="card.accessible == 1" class="accessible accessible1 pt-4">{{ t('general.notavailable') }}</h4>
                                <h4 v-if="card.accessible == 2" class="accessible accessible2 pt-4">{{ t('general.infutureavailable') }}</h4>
                                <p class="price pt-2">{{ card.price }}</p>
                                <p class="price_text pt-1">{{ t('general.mwst') }}</p>
                                </template>
                                <div v-if="card.accessible == 0 && basketLoaded == true && card.priceValue != 0" @click="addProductToCart(card.productId)" class="mt-4 py-2 px-5 d-none d-md-flex into_basket">{{ t('general.inbasket') }}</div>
                                <div v-if="basketLoaded == false" @click="gotosite(dealerUrl)" class="mt-4 py-2 px-5 d-none d-md-flex into_basket">{{ t('dealer.near') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-1"></div>
                <template v-if="basketLoaded == true">
                <div @click="toggleDetail(index)" class="py-3 px-5 d-flex mt-5 mb-2 d-md-none more_details more_details--mobile justify-content-center"><p>{{ t('general.moredetail') }}</p></div>
                </template>
                <div v-if="card.accessible == 0 && basketLoaded == true && card.price != 0" @click="addProductToCart(card.productId)" class="py-3 px-5 d-flex mt-0 mb-2 d-md-none into_basket  into_basket--mobile justify-content-center"><p>{{ t('general.inbasket') }}</p></div>
                <div v-if="basketLoaded == false" @click="gotosite(dealerUrl)" class="py-3 px-5 d-flex mt-0 mb-2 d-md-none into_basket  into_basket--mobile justify-content-center"><p>{{ t('dealer.near') }}</p></div>
            </div>
        </div>
        <div class="py-3 p-lg-0" v-else>
            <div :class="[theme == 'dark' ? 'bg-third-'+theme : 'bg-specialbackground-'+theme, 'text-primary-'+theme]" class="sparepartslist__landing-page__wrapper p-5">
                <div class="sparepartslist__landing-page__icon py-5 d-none justify-content-center">
                    <svg id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path fill="<?=$svgcolor2?>" d="m45.5 122h31c8.262 0 15 6.724 15 15l56.84 228.902c-15.773 7-26.84 22.756-26.84 41.098 0 24.814 20.186
                                45 45 45h17.763c-1.681 4.715-2.763 9.716-2.763 15 0 24.814 20.186 45 45 45s45-20.186 45-45c0-5.284-1.082-10.285-2.763-15h95.526c-1.681
                                4.715-2.763 9.716-2.763 15 0 24.814 20.186 45 45 45s45-20.186 45-45-20.186-45-45-45h-240c-8.262 0-15-6.724-15-15s6.738-15
                                15-15h276.416l68.584-240h-384.873l-6.475-25.854-.117.029c-4.878-19.572-22.472-34.175-43.535-34.175h-31c-24.814 0-45 20.186-45 45h30c0-8.276
                                6.738-15 15-15zm196 345c0 8.276-6.738 15-15 15s-15-6.724-15-15 6.738-15 15-15 15 6.724 15 15zm180 0c0 8.276-6.738 15-15 15s-15-6.724-15-15
                                6.738-15 15-15 15 6.724 15 15z"/>
                            <path fill="<?=$svgcolor2?>" d="m286.5 0h30v60h-30z"/>
                            <path fill="<?=$svgcolor2?>" d="m191.052 39.539h29.997v59.994h-29.997z" transform="matrix(.707 -.707 .707 .707 11.181 166.067)"/>
                            <path fill="<?=$svgcolor2?>" d="m366.952 54.538h59.994v29.997h-59.994z" transform="matrix(.707 -.707 .707 .707 67.094 301.052)"/>
                        </g>
                    </svg>
                </div>

                <h2 class="sparepartslist__landing-page__title pb-2 pb-lg-5 pt-5">{{t('general.noproducts')}}</h2>

                <p class="d-none sparepartslist__landing-page__text">{{t('')}}</p>

                <div class="pb-5 sparepartslist__landing-page__actions d-flex justify-content-center">
                    <a href="javascript:history.go(-1)" :class="'text-secondary-'+theme" class="btn-zoom btn-zoom--primary">
                        <span>{{t('general.gobackto')}}</span>
                        <div class="btn-zoom__bg"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {eventBus} from 'fire-vue-core';
import {FireI18n} from 'fire-js-i18n';
import gql from 'fake-tag';
import filters from "./filters.vue";

export default {
    name: 'cards',
    data: () => ({
        basketLoaded: false,
        timeoutHandle: '',
        popupmodalActive: false,
        popupmodalFailureActive: false,
        blockAddButton: false,
        svgcolor1: '',
        vidopen: 'undefined',
        detailopen: 'undefined',
        basket: Object,
        activeFilters: [
            {
                'filterId' : 'size',
                'value' : ''
            },
            {
                'filterId' : 'fabricclass',
                'value' : ''
            },
            {
                'filterId' : 'color',
                'value' : ''
            }
        ],
        cardsFiltered: [],
        cardsBase: [],
    }),
    components: {
        filters
    },
    directives: {},
    mixins: [],
    props: {
        activatefilter: Number,
        cards: Array,
        theme: String,
        propertyfilters: Array,
        dealerUrl: String
    },
    watch: {

    },
    created()
    {

    },
    destroyed()
    {

    },
    mounted()
    {
        this.setColors(this.theme);
        this.getBasket();
        this.cardsBase = JSON.parse(JSON.stringify(this.cards));
        this.applyFilters(this.activeFilters, this.cardsBase);
    },
    methods: {
        gotosite(url){
            window.location.href = url
        },
        activatePopupModal(){
            let self = this;
            if(self.popupmodalActive == true){
                clearTimeout(self.timeoutHandle);
            }
            self.popupmodalActive = true;
            self.timeoutHandle = setTimeout (
                function () {
                    self.popupmodalActive  = false;
                }
                , 3000);
        },
        activatePopupFailureModal(){
            let self = this;
            if(self.popupmodalFailureActive == true){
                clearTimeout(self.timeoutHandle);
            }
            self.popupmodalFailureActive = true;
            self.timeoutHandle = setTimeout (
                function () {
                    self.popupmodalFailureActive  = false;
                }
                , 3000);
        },
        toggleDetail(value){
            this.detailopen = value;
            if(value == 'undefined'){
                document.body.classList.remove("overflow-hidden");
            }else{
                document.body.classList.add("overflow-hidden");
            }
        },
        getFilters(value){
            this.activeFilters.forEach(function (item) {
                value.forEach(function (item2) {
                    if(item2.filterId == item.filterId){
                        if(item2.selected !== '' && item2.selected != 'none'){
                            if( item2.children[item2.selected].hasOwnProperty('title')){
                                item.value = item2.children[item2.selected].title;
                            }else{
                                item.value = item2.children[item2.selected];
                            }
                        }else{
                            item.value = '';
                        }
                    }
                })
            })
            this.applyFilters(this.activeFilters, this.cards);
        },
        applyFilters(filters, cardsBase){
            let filtersAllEmpty = true;
            let counter = 0;
            let self = this;
            let cardsTemp = [[],[],[]];
            filters.forEach(function (item) {
                if(counter == 0){
                    let hasChanged = false;
                    cardsBase.forEach(function (item2, key2) {
                        if(item.value != '' && item.value != 'none'){
                            filtersAllEmpty = false;
                            if(item.filterId == 'color') {
                                if(item.value != item2.filter.color.title) {
                                }else{
                                    console.log('cardsTempInside: ', cardsTemp);
                                    cardsTemp[counter].push(item2);
                                    hasChanged = true;
                                }
                            }
                            if(item.filterId == 'size'){
                                if(item.value != item2.filter.size) {
                                }else{
                                    console.log('cardsTempInside: ', cardsTemp);
                                    cardsTemp[counter].push(item2);
                                    hasChanged = true;
                                }
                            }
                            if(item.filterId == 'fabricclass'){
                                if(item.value != item2.filter.fabricclass) {
                                }else{
                                    console.log('cardsTempInside: ', cardsTemp);
                                    cardsTemp[counter].push(item2);
                                    hasChanged = true;
                                }
                            }
                        }
                    });
                    console.log('cardsTemp: ', cardsTemp);
                    self.cardsFiltered = JSON.parse(JSON.stringify(cardsTemp[counter]));
                    console.log('self.cardsFiltered: ', self.cardsFiltered);
                    if(hasChanged == true){
                        counter = counter + 1;
                    }
                }else{
                    let noneSelected = true;
                    cardsTemp[counter-1].forEach(function (item2, key2) {
                        console.log('entered second');
                        if(item.value != '' && item.value != 'none'){
                            noneSelected = false;
                            filtersAllEmpty = false;
                            if(item.filterId == 'color') {
                                console.log('check color');
                                if(item.value != item2.filter.color.title) {
                                }else{
                                    console.log('color is here');
                                    cardsTemp[counter].push(item2);
                                }
                            }
                            if(item.filterId == 'size'){
                                if(item.value != item2.filter.size) {
                                }else{
                                    cardsTemp[counter].push(item2);
                                }
                            }
                            if(item.filterId == 'fabricclass'){
                                if(item.value != item2.filter.fabricclass) {
                                }else{
                                    cardsTemp[counter].push(item2);
                                }
                            }
                        }
                    });
                    console.log('cardsTemp: ', cardsTemp);
                    if(noneSelected == false){
                        counter = counter + 1;
                    }
                    self.cardsFiltered = JSON.parse(JSON.stringify(cardsTemp[counter-1]));
                    console.log('self.cardsFiltered: ', self.cardsFiltered);
                }
            });
            if(filtersAllEmpty == true){
                self.cardsFiltered = JSON.parse(JSON.stringify(cardsBase));
            }
        },
        closeYoutubeVideo(id, index)
        {
            let element = document.getElementById(id);
            element.firstChild.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            this.vidopen = 'undefined';

        },
        t(key, options)
        {
            return FireI18n.t(key, options);
        },
        setColors(theme)
        {
            if(theme == 'dark')
            {
                this.svgcolor1 = '#fdc300';
            }
            else if(theme == 'white')
            {
                this.svgcolor1 = '#c80000';
            }
        },
        addProductToCart(id)
        {
            if (this.blockAddButton)
            {
                return
            }
            this.blockAddButton = true;

            let quantity
            let basketPositionId

            if (this.basket.get(id))
            {
                quantity = this.basket.get(id).qty
                quantity++
                basketPositionId = this.basket.get(id).id
            }
            else {
                quantity = 1
            }

            const basketPositionData = {
                'basket_position_id': basketPositionId,
                'shop_product_id_parent': id
            };

            let products = [];

            let data = {
                'shop_product_id': id,
                'quantity': quantity
            }
            products.push(data);


            basketPositionData.products = products;
            console.dir(basketPositionData)
            const body = {
                query: gql`mutation updateBasket($basketPositionData: BasketInputType){
                    updateBasket (basketPositionData: $basketPositionData) {
                        id
                        errors
                        positions {
                            shopProductIdParent
                            id
                            productQty
                            shopBasketId
                            productData
                            {
                                shopProductId
                            }
                            errors
                        }
                    }
                }`,
                variables: {basketPositionData}
            };

            fetch(graphqlApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': yii.getCsrfToken()
                },
                body: JSON.stringify(body)
            })
                .then(res => res.json())
                .then(res =>
                {
                    if(!res.errors)
                    {
                        let basketMap = new Map()
                        console.dir(res.data)
                        console.log(res.data.updateBasket.errors);
                        if (res?.data?.updateBasket?.errors.length == 0)
                        {
                            this.activatePopupModal();
                        }
                        else
                        {
                            this.activatePopupFailureModal();
                        }
                        res.data.updateBasket.positions.forEach(p =>
                        {
                            basketMap.set(p.productData.shopProductId, {'id' : p.id, 'qty' : p.productQty} )
                        })
                        this.basket = basketMap;
                        eventBus.$emit('CallGetBasketProducts');
                    }
                    this.blockAddButton = false
                });
        },
        getBasket()
        {
            const body = {
                query: gql`query {
                              basket {
                                errors
                                positions {
                                  id
                                  productCount
                                  productQty
                                  productData {
                                    shopProductId
                                  }
                                }
                              }
                            }`,
            };

            fetch(graphqlApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': yii.getCsrfToken()
                },
                body: JSON.stringify(body)
            })
                .then(res => res.json())
                .then(res =>
                {
                    console.dir(res)
                    if(!res.error)
                    {
                        let basketMap = new Map()
                        this.basket = res.data.basket.positions
                        res.data.basket.positions.forEach(p =>
                        {
                            basketMap.set(p.productData.shopProductId, {'id' : p.id, 'qty' : p.productQty} )
                        })
                        this.basket = basketMap;
              // this.basketLoaded = true; disabled for now
                    }
                });
        },
    }
};
</script>

<style lang="scss">
@import "frontend/styles/framework";

.popupmodal {
    z-index: 99999;
    top: 25%;
    max-width: 656px;
    left: 50%;
    transform: translate(-50%,-50%);
    opacity: 0;
    visibility: hidden;
    transition: all 1s;
    &__inner{
        padding: 9%;
        p{
            font-size: 1.05rem;
            font-weight: 300;
        }
    }
    &.open {
        opacity: 1;
        visibility: visible;
    }
    @media (min-width: 400px) {
        &__inner{
            p{
                font-size: 1.35rem;
            }
        }
    }
    @media (min-width: 992px) {
        top: 50%;
        &__inner{
            p{
                font-size: 1.35rem;
            }
        }
    }
    @media (max-width: 400px) {
        top: 30%;
    }
}

.videoPopup {
    background-color: rgba(0, 0, 0, 0.5);
    top: 0px;
    left: 0px;
    z-index: 99;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;

    &.open {
        visibility: visible;
        opacity: 1;
    }

    iframe {
        max-width: 1200px;
        max-height: 674px;
        width: 85%;
        height: 85%;
    }
}

.videoPopupCloser {
    cursor: pointer;
    top: 3%;
    right: 2%;
    transition: all 0.3s;
    z-index: 100;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;

    &.open {
        visibility: visible;
        opacity: 1;
    }

    &:hover {
        transform: scale(1.05);
    }
}

.sparepartsproductselection__productlist {
    &__item {
        padding-top: 35px;
        padding-bottom: 15px;
        flex-direction: column;

        &--dark {
            &.sparepartsproductselection__productlist__item {
                border-top: 1px solid $third-dark;
            }

            .into_basket {
                color: $secondary-dark;
                border: 1px solid $secondary-dark;

                &:hover {
                    background-color: $secondary-dark;
                    color: $dark;
                }
            }

            .more_details {
                color: $white;
                border: 1px solid $white;

                &:hover {
                    background-color: $white;
                    color: $dark;
                }
            }
        }

        &--white {
            &.sparepartsproductselection__productlist__item {
                border-top: 1px solid $third-white;
            }

            .into_basket {
                color: $white;
                border: 1px solid $secondary-white;
                background-color: $secondary-white;

                &:hover {
                    background-color: $white;
                    color: $secondary-white;
                }
            }

            .more_details {
                color: $third-white;
                border: 1px solid $third-white;
                background-color: $white;

                &:hover {
                    background-color: $third-white;
                    color: $white;
                }
            }
        }

        &:first-child {
            padding-top: 0px;
            border-top: none;
        }

        &__img {

            p {
                font-size: 0.55rem;

                span {
                    font-weight: 100;
                }
            }

            &__inner {
                min-width: 130px;
                height: 130px;
                background-size: 70%;
                background-repeat: no-repeat;
                background-position: center;

                &--fabric {
                    background-size: cover;
                }
            }

            > div:last-child {
                svg {
                    width: 15px;
                    height: 15px;
                }
            }
        }

        &__details {
            .detailContainer {
                overflow-y: scroll;
                -ms-overflow-style: none; /* for Internet Explorer, Edge */
                scrollbar-width: none; /* for Firefox */
                overflow-y: scroll;
                &::-webkit-scrollbar {
                    display: none; /* for Chrome, Safari, and Opera */
                }
                top: 0%;
                left: 103%;
                visibility: hidden;
                opacity: 0;
                transition: all 0.3s;
                z-index: 9999;

                .backToSection {
                    &--white {
                        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                    }

                    &--dark {
                        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    }
                }

                &.open {
                    visibility: visible;
                    opacity: 1;
                    left: 0%;
                }
            }

            div.videolink {
                cursor: pointer;

                p {
                    transition: padding-right 0.3s;
                    padding-right: 10px;
                    font-size: 0.85rem;
                }

                &:hover {
                    p {
                        padding-right: 15px;
                    }
                }
            }

            h2 {
                font-size: 1.25rem;
                line-height: 1.5rem;

                span {
                    font-size: 0.85rem;
                    line-height: 1.2rem;
                    font-weight: 300;
                }
            }

            h3 {
                font-size: 0.8rem;
                font-weight: 500;
                word-break: break-all;
                span {
                    font-weight: 200;
                }
            }

            h4 {
                &.accessible {
                    font-size: 0.7rem;
                    font-weight: 200;
                }

                &.accessible0 {
                    color: #00f009;
                }

                &.accessible1 {
                    color: red;
                }

                &.accessible2 {
                    color: #FDC300;
                }
            }

            p {
                &.price {
                    font-size: 1.3rem;
                    font-weight: 400;

                    &_text {
                        font-size: 0.7rem;
                        font-weight: 200;
                        text-align: end;
                    }
                }
            }
        }

        .into_basket {
            cursor: pointer;
            font-weight: 200;
            font-size: 0.7rem;

            &--mobile {
                font-size: 0.85rem;
                font-weight: 400;
            }

            transition: background-color 0.3s;
        }

        .more_details {
            cursor: pointer;
            font-weight: 200;
            font-size: 0.7rem;

            &--mobile {
                font-size: 0.85rem;
                font-weight: 400;
            }

            transition: background-color 0.3s;
        }
    }
}

@media (min-width: 400px) {

}

@media (min-width: 576px) {
    .sparepartsproductselection__productlist {
        &__item {
            flex-direction: row;

            &__details {
                div.videolink {
                    p {
                        font-size: 1rem;
                    }
                }
            }
        }
    }
}

@media (min-width: $media-tablet) {
    .sparepartsproductselection__productlist {
        &__item {
            padding-bottom: 35px;

            &__img {

                p {
                    font-size: 0.75rem;
                }

                &__inner {
                    min-width: 200px;
                    height: 200px;
                }

                > div:last-child {
                    svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            }

            &__details {
                .detailContainer {
                    visibility: visible;
                    opacity: 1;
                    z-index: 0;
                }

                h2 {
                    font-size: 1.65rem;
                    line-height: 2rem;

                    span {
                        font-size: 1.3rem;
                        line-height: 1.5rem;
                    }
                }
            }
        }
    }
}

@media (min-width: $media-laptop) {

}
</style>